<script>
import { mapGetters } from 'vuex'
import { getKolBasicRecordDeptScope } from '@/api/kol_basic_record'

export default {
  name: 'ArtistDataScope',
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      scopeMap: {
        'all': '全部',
        'dept': '本部',
        'group': '本组',
        'none': '未设置'
      },
      scopeTitle: ''
    }
  },
  methods: {
    loadScope() {
      getKolBasicRecordDeptScope().then(({ scope_type }) => {
        this.scopeTitle = this.scopeMap[scope_type] || '未知'
      })
    }
  },
  created() {
    this.loadScope()
  }
}

</script>

<template>
  <div style='display: inline'>
    <el-tag effect='plain' size='small' type='success'><span :title='scopeTitle'>数据范围：</span>
      <span v-if='userPermissions.indexOf("kol_basic_scope_all")>-1'>全部</span>
      <span v-else-if='userPermissions.indexOf("kol_basic_scope_dept")>-1'>本部</span>
      <span v-else-if='userPermissions.indexOf("kol_basic_scope_group")>-1'>本组</span>
      <span v-else>无权限</span>
    </el-tag>
  </div>
</template>

<style scoped>

</style>
